import React from "react";


const Led = () => {

    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/box-blue.png" alt="cpu" className="icon led-icon" />
                <span>周辺機器</span>
            </div>
            <div className="led-box row">
                <div className="col-md-7">
                    <div className="title-box"><span>1. LED チェック</span></div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>LEDライト</th>
                                <th>ステータス</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><img src="img/red-circle.png" />(LED 赤) on/blink</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td><img src="img/green-circle.png" />(LED 緑) on/blink</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td><img src="img/blue-circle.png" />(LED 青) on/blink</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-md-5 smart-ai">
                    <img src="img/poke.png" className="poke" />
                    <img src="img/blink.gif" className="smartai" />
                </div>
                <div className="col-md-12">
                    <span className="info-message"><img src="img/info.png" alt="info" />
                        テストデバイスのすべての色でリード点滅を確認してください
                    </span>
                </div>

                {/* <div className="col-md-12">
                    <div className="box-wrapper failed-wrapper">
                        <span>LED は点灯して点滅していますか?</span>
                        <div className="two-button-box">
                            <button>はい</button>
                            <button>いいえ</button>
                        </div>
                    </div>
                </div> */}
                {/* <div className="col-md-12">
                    <div className="box-wrapper failed-wrapper">
                        <span>LEDの接続を確認できません。</span>
                        <div className="two-button-box">
                            <button className="retry">リトライ</button>
                            <button className="skip">スキップ</button>
                        </div>
                    </div>
                </div> */}

            </div>


        </div>

    );
};

export default Led;